import {
    listWebApps,
    createWebApp,
    updateWebApp,
    deleteWebApp,
    getWebApp,
    checkSlugAvailability,
    uploadWebAppProject,
} from "../../api/webapps";

const webapps = {
    namespaced: true,
    state: {
        webApps: [],
        loading: false,
        uploadProgress: 0,
    },
    getters: {
        getWebAppById: (state) => (id) => {
            return state.webApps.find((app) => app._id === id);
        },
        getWebAppBySlug: (state) => (slug) => {
            return state.webApps.find((app) => app.slug === slug);
        },
        getEnabledWebApps: (state) => {
            return state.webApps.filter((app) => app.enabled && !app.isDeleted);
        },
    },
    mutations: {
        SET_WEB_APPS(state, webApps) {
            state.webApps = webApps;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        SET_UPLOAD_PROGRESS(state, progress) {
            state.uploadProgress = progress;
        },
        ADD_WEB_APP(state, webApp) {
            state.webApps.push(webApp);
        },
        UPDATE_WEB_APP(state, updatedWebApp) {
            const index = state.webApps.findIndex((app) => app._id === updatedWebApp._id);
            if (index !== -1) {
                state.webApps.splice(index, 1, updatedWebApp);
            }
        },
        REMOVE_WEB_APP(state, webAppId) {
            state.webApps = state.webApps.filter((app) => app._id !== webAppId);
        },
    },
    actions: {
        async fetchWebApps({ commit }) {
            try {
                commit("SET_LOADING", true);
                const response = await listWebApps();
                commit("SET_WEB_APPS", response.data || response);
                return response.data || response;
            } catch (error) {
                console.error("Error fetching web apps:", error);
                throw error;
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async createWebApp({ commit }, webAppData) {
            try {
                const response = await createWebApp(webAppData);
                commit("ADD_WEB_APP", response.data || response);
                return response.data || response;
            } catch (error) {
                console.error("Error creating web app:", error);
                throw error;
            }
        },
        async updateWebApp({ commit }, { id, data }) {
            try {
                const response = await updateWebApp(id, data);
                commit("UPDATE_WEB_APP", response.data || response);
                return response.data || response;
            } catch (error) {
                console.error("Error updating web app:", error);
                throw error;
            }
        },
        async deleteWebApp({ commit }, webAppId) {
            try {
                await deleteWebApp(webAppId);
                commit("REMOVE_WEB_APP", webAppId);
                return true;
            } catch (error) {
                console.error("Error deleting web app:", error);
                throw error;
            }
        },
        async getWebApp({ commit }, webAppId) {
            try {
                const response = await getWebApp(webAppId);
                return response.data || response;
            } catch (error) {
                console.error("Error getting web app:", error);
                throw error;
            }
        },
        async checkSlugAvailability({ commit }, { slug, excludeId }) {
            try {
                const response = await checkSlugAvailability(slug, excludeId);
                return response.data || response;
            } catch (error) {
                console.error("Error checking slug:", error);
                throw error;
            }
        },
        async uploadProject({ commit }, { id, file }) {
            try {
                commit("SET_UPLOAD_PROGRESS", 0);
                
                const response = await uploadWebAppProject(id, file, (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    commit("SET_UPLOAD_PROGRESS", percentCompleted);
                });
                
                commit("UPDATE_WEB_APP", response.data || response);
                commit("SET_UPLOAD_PROGRESS", 0);
                
                return response.data || response;
            } catch (error) {
                commit("SET_UPLOAD_PROGRESS", 0);
                console.error("Error uploading project:", error);
                throw error;
            }
        },
    },
};

export default webapps;
